export const mapWizardConfig = (wizardConfig: any) => {
    const visitMap: any = {};
    const instrumentMap: any = {};
    Object.keys(wizardConfig.constructs || {}).forEach((construct: string) => {
        Object.keys(wizardConfig.constructs[construct] || {}).forEach((instrument: string) => {
            if (!(instrument in instrumentMap)) {
                instrumentMap[instrument] = []
            }
            instrumentMap[instrument].push(construct);
        });
    });
    Object.keys(wizardConfig.allInstruments || {}).forEach((instrument: string) => {
        if (wizardConfig.allInstruments[instrument].visitLabels !== null) {
            wizardConfig.allInstruments[instrument].visitLabels.forEach((visit: string) => {
                if (!(visit in visitMap)) {
                    visitMap[visit] = {
                        instruments: [],
                        constructs: new Set()
                    }
                }
                visitMap[visit].instruments.push(instrument);
                instrumentMap[instrument].forEach((item: any) => visitMap[visit].constructs.add(item));
            })
        }
    });

    // Looping again to make sure all visits have been processed
    Object.keys(wizardConfig.allInstruments || {}).forEach((instrument: string) => {
        if (wizardConfig.allInstruments[instrument].staticInstrument) {
            Object.keys(visitMap || {}).forEach((visit: string) => {
                visitMap[visit].instruments.push(instrument);
                instrumentMap[instrument].forEach((item: any) => visitMap[visit].constructs.add(item));
            })
        }
    });

    Object.keys(visitMap || {}).forEach((visit: string) => {
        visitMap[visit].constructs = Array.from(visitMap[visit].constructs);
    });

    return {
        ...wizardConfig,
        visitMap: visitMap
    }
}